const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");

const app = firebase.initializeApp({
  apiKey: "AIzaSyCJDsurs8av6rLIV3_fNmDxJOr5trWWmk8",
  authDomain: "cham-blog.firebaseapp.com",
  databaseURL: "https://cham-blog.firebaseio.com",
  projectId: "cham-blog",
  storageBucket: "cham-blog.appspot.com",
  messagingSenderId: "338527369193"
});

const db = firebase.firestore();
db.settings( {timestampsInSnapshots: true});
const repos = db.collection('repos');
const works = db.collection('works');

export default {
  db,
  repos,
  works,
}


// WEBPACK FOOTER //
// ./src/firebase.js